<template>
  <div class="relative">
    <AhaInfoBox class="mb-3">
      Changing the settings here takes the same
      effect as doing it from any Q&A slide.
    </AhaInfoBox>
    <p class="mb-3 text-sm font-bold text-secondary-100">
      When can the audience send you questions?
    </p>
    <div class="pl-4">
      <aha-radio
        class="mb-3"
        value="true"
        v-model="presentation.qnaAllSlide"
        @change="changeSettingPresentation('qnaAllSlide')"
        name="customCheckboxqna"
      >
        On all slides
      </aha-radio>
      <aha-radio
        class="mb-3"
        value="false"
        v-model="presentation.qnaAllSlide"
        @change="changeSettingPresentation('qnaAllSlide')"
        name="customCheckboxqna"
      >
        Only on Q&A slides
      </aha-radio>
    </div>

    <QnAModerationCheckBox is-on-settings-menu />

    <aha-checkbox
      class="mb-3"
      id="allowAudienceSeeEachOther"
      v-model="presentation.qnaAudienceShowAll"
      @change="changeSettingPresentation('qnaAudienceShowAll')"
    >
      <span>
        Allow audience to see each other's questions
        <aha-icon
          class="ml-1 text-base-70"
          name="question"
          viewBox="0 0 24 24"
          width="15"
          height="15"
          v-tooltip="allowAudienceSeeEachOtherTooltip"
        />
      </span>
    </aha-checkbox>

    <aha-checkbox
      class="mb-3"
      id="allowAnonymous"
      v-model="presentation.qnaAnonymous"
      @change="changeSettingPresentation('qnaAnonymous')"
    >
      <span>
        Allow anonymous questions
        <aha-icon
          class="ml-1 text-base-70"
          name="question"
          viewBox="0 0 24 24"
          width="15"
          height="15"
          v-tooltip="allowAnonymousQuestionsTooltip"
        />
      </span>
    </aha-checkbox>

    <div class="overlay-disable-setting" v-if="isDisableEditPresentation"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Socket from '@/socket'
import utils from '@/util'
import gaCategories from '@/constant/gaCategories'

import QnAModerationCheckBox from '@/components/presentations/QnAModerationCheckBox.vue'
import QnAModerationCheckBoxContainer from '@/containers/qna-moderation/QnAModerationCheckBox'

const gaTrackingEventLabel = 'Settings Menu > Q&A with your audience'

export default {
  components: {
    QnAModerationCheckBox: QnAModerationCheckBoxContainer(QnAModerationCheckBox),
  },
  data() {
    return {
      gaTrackingEventLabel,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
    }),
    allowAudienceSeeEachOtherTooltip() {
      return 'Allow the audience to see all questions on their smartphones and vote for what they want to be answered most'
    },
    allowAnonymousQuestionsTooltip() {
      return 'Allow your audience to submit questions without providing their names'
    },
  },
  methods: {
    changeSettingPresentation(type) {
      const payload = {
        socketId: Socket.getSocketId(),
      }
      let text = ''
      if (type === 'qnaAllSlide') {
        payload.qnaAllSlide = this.presentation.qnaAllSlide
        text = 'Q&A on all slides'
        if (payload.qnaAllSlide === 'false') {
          text = 'Q&A only on Q&A slides'
        }
        utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, this.gaTrackingEventLabel, text)
      } else if (type === 'qnaAudienceShowAll') {
        payload.qnaAudienceShowAll = this.presentation.qnaAudienceShowAll

        text = "Checked allow audience to see each other's questions"
        if (!payload.qnaAudienceShowAll) {
          text = "Unchecked allow audience to see each other's questions"
        }
        utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, this.gaTrackingEventLabel, text)
      } else if (type === 'qnaAnonymous') {
        payload.qnaAnonymous = this.presentation.qnaAnonymous
        text = 'Checked allow anonymous questions'
        if (!payload.qnaAnonymous) {
          text = 'Uncheck allow anonymous questions'
        }
        utils.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, this.gaTrackingEventLabel, text)
      }
      this.$emit('updatePresentation', payload)
    },
  },
}
</script>

<style lang="scss" scoped>
.overlay-disable-setting {
  @apply bg-base-0 opacity-50 absolute left-0 top-0 w-full h-full;
}
</style>
